// @ts-nocheck
import getColor from "@insite/mobius/utilities/getColor";
import ArrowBackward, { ArrowBackwardOffset } from "@store/Library/Components/Toolkit/Icons/ArrowBackward";
import ChevronRight from "@store/Library/Components/Toolkit/Icons/ChevronRight";
import { menuPanelRowStyles } from "@store/Themes/common/mixins/menu";
import { buttonResetProps } from "@store/Themes/common/props/button";
import { menuPanelProps } from "@store/Themes/common/props/menu";
import Styleguide from "@toolkit/Framework/Types/Styleguide";
import { css } from "styled-components";

/* Store Custom Code - Start */
import { linkActionStyles } from "@store/Themes/common/mixins/link";
import ArrowForward, { ArrowForwardOffset } from "@store/Library/Components/Toolkit/Icons/ArrowForward";
/* Store Custom Code - End */

const panelMenu: Styleguide["panelMenu"] = {
    defaultProps: {
        cssOverrides: {
            children: menuPanelProps.wrapperCss,
            menu: menuPanelProps.menuCss,
        },
        closeButtonPanelRowProps: {
            css: menuPanelProps.headerCss,
        },
        closeButtonProps: menuPanelProps.closeButton,
        closeIconProps: menuPanelProps.closeButtonIcon,
        parentPanelRowProps: {
            css: css`
                ${menuPanelRowStyles({
                    iconPosition: "right",
                    color: "inherit",
                    hoverColor: "inherit",
                    hoverUnderline: false,
                })}
                /* Store Custom Code - Start */
                padding: ${x => x.theme.design.menu.panel.largerRowPadding};
                padding-right: 0;
                padding-left: 0;
                margin: ${x => x.theme.design.menu.panel.largerRowPadding};
                margin-top: 0;
                margin-bottom: 0;
                width: auto;
                /* Store Custom Code - End */
            `,
        },
        parentLinkProps: {
            css: css`
                ${menuPanelRowStyles({
                    iconPosition: "right",
                    color: "menu.mainNavigation.accent",
                    hoverColor: "menu.mainNavigation.accentHover",
                    borderColor: "transparent",
                })}

                width: auto;
                padding: 0;
                white-space: nowrap;
                ${linkActionStyles() /* Store Custom Code */}
            `,
        },
        parentTypographyProps: {
            ellipsis: true,
            css: css`
                text-transform: none; /* Store Custom Code */
                /* Store Custom Code - Start */
                font-family: ${x => x.theme.design.typography.fontFamily.title};
                /* Store Custom Code - End */
            `,
        },
        backButtonProps: {
            ...buttonResetProps,
            css: css`
                ${buttonResetProps.css}
                ${menuPanelRowStyles({
                    borderColor: "transparent",
                    color: "menu.mainNavigation.accent",
                    hoverColor: null, // Store Custom Code
                    iconOffset: ArrowBackwardOffset,
                    // Store Custom Code
                    accentHoverColor: null,
                })}
                display: flex;
                align-items: center;
                width: 100%;
                text-align: left;
                font-weight: ${x => x.theme.design.typography.weight.semibold /* Store Custom Code */};
                padding-top: 0;
                padding-bottom: 0;
                /* Store Custom Code - Start */
                font-size: ${x => x.theme.design.typography.size.smaller};
                /* Store Custom Code - End */
            `,
        },
        backTitleTypographyProps: { ellipsis: true },
        backIconProps: { src: ArrowBackward },
        bodyColor: "transparent",
        panelRowProps: {
            css: css`
                ${menuPanelRowStyles({
                    iconPosition: "right",
                    borderColor: "transparent",
                    iconOffset: ArrowForwardOffset, // Store Custom Code
                    // Store Custom Code
                    hoverColor: null,
                    accentHoverColor: null,
                })}
            `,
            isCurrentCss: css`
                background-color: transparent;
                text-decoration: underline;
                color: ${getColor("menu.mainNavigation.contrast") /* Store Custom Code */};
            `,
            moreIconProps: { src: ArrowForward },
        },
        childTypographyProps: {
            size: "inherit",
            weight: "initial",
        },
    },
};

export default panelMenu;
